module.exports = __webpack_public_path__ + "img/img-pickup02.3c3a97f3.jpg";